import { IProductInstallmentsViewConfig } from '../views/product-installments-price/ProductInstallmentsPrice';
import { IShadePickerComponentViewConfig } from '../interfaces/IShadePicker';
import { IProductAutoReplenishOptions } from '../views/product-auto-replenish/ProductAutoReplenish';
import { IProductPriceRangeConfig } from '../interfaces/IProductPrice';

export enum ComponentTypes {
    PRODUCT_GRID = 'productGrid',
    PRODUCT_QUICKSHOP = 'productQuickshop',
    PRODUCT_FULL = 'productFull',
    PRODUCT_BRIEF = 'productBrief',
    PRODUCT_SHADES_SIDEBAR = 'productShadesSidebar',
    PRODUCT_STICKY_ADD_TO_BAG = 'productStickyAddToBag'
}

export type allowedType =
    | IProductInstallmentsViewConfig
    | IShadePickerComponentViewConfig
    | IProductAutoReplenishOptions
    | IProductPriceRangeConfig
    | undefined;

export type ComponentTypesConfigByType = { [K in ComponentTypes]?: allowedType };
